import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { type IPropertyDefinition } from '@suvo/shared/property';
import { type IBTileDefinition } from '@suvo/shared/tile';
import { definitions, names, type TName } from '../../../common/tile';
import { SubformComponentBase } from '../../../shared/forms/subform-component-base';
import { PropertyWidgetComponent } from '../../../shared/property-widget/property-widget.component';

@Component({
  standalone:true,
  selector: 'tile-instance-control',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PropertyWidgetComponent],
  template: `
    <h1>{{ selectedName }}</h1>

    @if (definition) {
      <form [formGroup]="form">
        @for (property of definition.properties; track property.name) {
          <property-widget [property]="property" />
        }
      </form>
    }
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TileInstanceControl,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: TileInstanceControl,
    },
  ],
})
export class TileInstanceControl
  extends SubformComponentBase<IBTileDefinition>
  implements OnChanges
{
  ngOnChanges() {
    if (!this.selectedName) {
      return;
    }
    this.useDescriminator = false;
    this.definition = this.definitions.find((d) => d.name == this.selectedName);
    if (!this.definition) {
      // Unknown tile type or missing definition; keep the form empty.
      this.rebuildValueForm([]);
      return;
    }
    this.rebuildValueForm(this.definition.properties);
  }

  @Input()
  selectedName?: TName;
  useDescriminator: boolean = true;
  names = names;
  definitions = definitions;
  definition?: IBTileDefinition;
  form = new FormGroup({});

  nameChanged($event: MatSelectChange) {
    this.selectedName = $event.value;
    this.definition = this.definitions.find((d) => d.name == this.selectedName);
    if (!this.definition) {
      this.rebuildValueForm([]);
      return;
    }
    this.rebuildValueForm(this.definition.properties);
  }

  rebuildValueForm(properties: IPropertyDefinition[]) {
    Object.keys(this.form.controls).forEach((key) => {
      this.form.removeControl(key);
    });
    if (this.useDescriminator) {
      this.form.addControl('type', new FormControl(this.selectedName));
    }
    for (const property of properties) {
      this.form.addControl(property.name, new FormControl());
    }
  }
}
